/* eslint-disable import/no-default-export */
export default {
  Login: 'Login',
  Logout: 'Logout',
  Ok: 'Ok',
  Save: 'Save',
  Delete: 'Delete',
  Edit: 'Edit',
  Back: 'Back',
  Continue: 'Continue',
  Search: 'Search',
  Cancel: 'Cancel',
  Add: 'Add',
  Note: 'Note',
  Select: 'Select'
}
